/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LeadScreenerLeadInfoRace
 */
export interface LeadScreenerLeadInfoRace {
    /**
     * 
     * @type {string}
     * @memberof LeadScreenerLeadInfoRace
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof LeadScreenerLeadInfoRace
     */
    name?: string;
}

/**
 * Check if a given object implements the LeadScreenerLeadInfoRace interface.
 */
export function instanceOfLeadScreenerLeadInfoRace(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function LeadScreenerLeadInfoRaceFromJSON(json: any): LeadScreenerLeadInfoRace {
    return LeadScreenerLeadInfoRaceFromJSONTyped(json, false);
}

export function LeadScreenerLeadInfoRaceFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadScreenerLeadInfoRace {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function LeadScreenerLeadInfoRaceToJSON(value?: LeadScreenerLeadInfoRace | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}

